import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/images/logo.svg";
import { searchReducer } from "../redux/features/filter/filterSlice";

export default function NavBar() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [tab, setTab] = useState("");

  useEffect(() => {
    setTab(
      location.pathname === "/" || location.pathname.includes("/books/edit")
        ? true
        : false
    );
  }, [location.pathname]);

  const handleSearch = (e) => {
    dispatch(searchReducer(e.target.value.trim()));
  };

  return (
    <nav className="py-4 2xl:px-6">
      <div className="container flex items-center justify-between">
        <img
          src={logo}
          width="150px"
          className="object-contain"
          alt="LWS Logo"
        />

        <ul className="hidden md:flex items-center space-x-6">
          <Link
            className={`cursor-pointer ${tab && `font-semibold`}`}
            to="/"
            id="lws-bookStore"
            onClick={() => {
              setTab(true);
            }}
          >
            <li>Book Store</li>
          </Link>
          <Link
            className={`cursor-pointer ${!tab && `font-semibold`}`}
            to="/books/add"
            id="lws-addBook"
            onClick={() => {
              setTab(false);
            }}
          >
            <li>Add Book</li>
          </Link>
        </ul>

        <form className="flex items-center">
          <div className="group relative rounded-md bg-white">
            <svg
              width="20"
              height="20"
              fill="currentColor"
              className="absolute left-3 top-1/2 -mt-2.5 text-slate-400 pointer-events-none group-focus-within:text-primary"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
              ></path>
            </svg>
            <input
              type="text"
              placeholder="Filter books..."
              className="search"
              id="lws-search"
              onChange={handleSearch}
            />
          </div>
        </form>
      </div>
    </nav>
  );
}
